// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.site-footer {
  background: #0C0907;
  padding: 56px 0 40px;
  color: #c4ceda;
}
 
.footer-inner {
  max-width: 1300px;
  margin: 0 auto;
  padding: 0 56px;
}
 
.footer-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  flex-wrap: wrap;
  margin-bottom: 28px;
  padding-bottom: 32px;
  border-bottom: 0.5px solid rgba(255, 255, 255, 0.1);
}
 
.footer-logos {
  display: flex;
  align-items: center;
  gap: 24px;
}
 .footer-contact {
  display: flex;
  flex-direction: column;
  align-items: flex-start; /* changed from flex-end */
  gap: 8px;
}

.footer-url {
  font-size: 15px;
  color: #fff;
}

.footer-instagram {
  display: flex;
  align-items: center;
  gap: 7px;
  font-size: 15px;
  color: #fff; /* changed to match footer-url */
  text-decoration: none;
  transition: color 0.2s ease;
}

.footer-instagram:hover {
  color: #EE5B43;
  text-decoration: underline;
}

.footer-instagram-icon {
  width: 25px;
  height: 25px;
  object-fit: contain;
}
.footer-logo-img {
  height: 28px;
  opacity: 0.9;
  object-fit: contain;
}
 
.footer-logo-sep {
  width: 1px;
  height: 30px;
  background: rgba(255, 255, 255, 0.15);
}
 
.footer-contact {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
}
 
.footer-url {
  font-size: 15px;
  color: #fff;
}
 
.footer-email {
  display: flex;
  align-items: center;
  gap: 7px;
  font-size: 15px;
  font-weight: 600;
  color: #fff;
  text-decoration: none;
}
 
.footer-email:hover {
  text-decoration: underline;
}
 
.footer-bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  flex-wrap: wrap;
}
 
.footer-copyright {
  font-size: 13px;
  color: #93A1B1;
}
 
.footer-legal-link {
  font-size: 13px;
  color: #c4ceda;
  text-decoration: none;
  transition: color 0.2s ease;
}
 
.footer-legal-link:hover {
  color: #EE5B43;
  text-decoration: underline;
}
 
/* ── ≥ 1501px ── */
@media (min-width: 1850px) {
  .footer-inner {
    max-width: 2000px;
    padding: 0 140px;
  }
}
 
/* ── ≤ 768px ── */
@media (max-width: 768px) {
  .footer-inner {
    padding: 0 24px;
  }
  .footer-top {
    flex-direction: column;
    align-items: center;
  }
  .footer-contact {
    align-items: center;
  }
  .footer-bottom {
    flex-direction: column;
    align-items: center;
    gap: 8px;
  }
  .footer-logos {
    gap: 14px;
  }
  .footer-logo-img {
    height: 18px;
  }
  .footer-logo-sep {
    height: 16px;
  }
}
 
/* ── ≤ 480px ── */
@media (max-width: 480px) {
  .footer-logos {
    gap: 10px;
  }
  .footer-logo-img {
    height: 14px;
  }
  .footer-logo-sep {
    height: 13px;
  }
 
  .footer-top {
    align-items: center;
    text-align: center;
  }
 
  .footer-contact {
    align-items: center;
    text-align: center;
  }
 
  .footer-bottom {
    align-items: center;
    text-align: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/organisms/Footer/Footer.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,mDAAmD;AACrD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;CACC;EACC,aAAa;EACb,sBAAsB;EACtB,uBAAuB,EAAE,0BAA0B;EACnD,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,WAAW,EAAE,gCAAgC;EAC7C,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA,mBAAmB;AACnB;EACE;IACE,iBAAiB;IACjB,gBAAgB;EAClB;AACF;;AAEA,kBAAkB;AAClB;EACE;IACE,eAAe;EACjB;EACA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;EACV;EACA;IACE,SAAS;EACX;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;AACF;;AAEA,kBAAkB;AAClB;EACE;IACE,SAAS;EACX;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;AACF","sourcesContent":[".site-footer {\n  background: #0C0907;\n  padding: 56px 0 40px;\n  color: #c4ceda;\n}\n \n.footer-inner {\n  max-width: 1300px;\n  margin: 0 auto;\n  padding: 0 56px;\n}\n \n.footer-top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 24px;\n  flex-wrap: wrap;\n  margin-bottom: 28px;\n  padding-bottom: 32px;\n  border-bottom: 0.5px solid rgba(255, 255, 255, 0.1);\n}\n \n.footer-logos {\n  display: flex;\n  align-items: center;\n  gap: 24px;\n}\n .footer-contact {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start; /* changed from flex-end */\n  gap: 8px;\n}\n\n.footer-url {\n  font-size: 15px;\n  color: #fff;\n}\n\n.footer-instagram {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  font-size: 15px;\n  color: #fff; /* changed to match footer-url */\n  text-decoration: none;\n  transition: color 0.2s ease;\n}\n\n.footer-instagram:hover {\n  color: #EE5B43;\n  text-decoration: underline;\n}\n\n.footer-instagram-icon {\n  width: 25px;\n  height: 25px;\n  object-fit: contain;\n}\n.footer-logo-img {\n  height: 28px;\n  opacity: 0.9;\n  object-fit: contain;\n}\n \n.footer-logo-sep {\n  width: 1px;\n  height: 30px;\n  background: rgba(255, 255, 255, 0.15);\n}\n \n.footer-contact {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 8px;\n}\n \n.footer-url {\n  font-size: 15px;\n  color: #fff;\n}\n \n.footer-email {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  font-size: 15px;\n  font-weight: 600;\n  color: #fff;\n  text-decoration: none;\n}\n \n.footer-email:hover {\n  text-decoration: underline;\n}\n \n.footer-bottom {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 24px;\n  flex-wrap: wrap;\n}\n \n.footer-copyright {\n  font-size: 13px;\n  color: #93A1B1;\n}\n \n.footer-legal-link {\n  font-size: 13px;\n  color: #c4ceda;\n  text-decoration: none;\n  transition: color 0.2s ease;\n}\n \n.footer-legal-link:hover {\n  color: #EE5B43;\n  text-decoration: underline;\n}\n \n/* ── ≥ 1501px ── */\n@media (min-width: 1850px) {\n  .footer-inner {\n    max-width: 2000px;\n    padding: 0 140px;\n  }\n}\n \n/* ── ≤ 768px ── */\n@media (max-width: 768px) {\n  .footer-inner {\n    padding: 0 24px;\n  }\n  .footer-top {\n    flex-direction: column;\n    align-items: center;\n  }\n  .footer-contact {\n    align-items: center;\n  }\n  .footer-bottom {\n    flex-direction: column;\n    align-items: center;\n    gap: 8px;\n  }\n  .footer-logos {\n    gap: 14px;\n  }\n  .footer-logo-img {\n    height: 18px;\n  }\n  .footer-logo-sep {\n    height: 16px;\n  }\n}\n \n/* ── ≤ 480px ── */\n@media (max-width: 480px) {\n  .footer-logos {\n    gap: 10px;\n  }\n  .footer-logo-img {\n    height: 14px;\n  }\n  .footer-logo-sep {\n    height: 13px;\n  }\n \n  .footer-top {\n    align-items: center;\n    text-align: center;\n  }\n \n  .footer-contact {\n    align-items: center;\n    text-align: center;\n  }\n \n  .footer-bottom {\n    align-items: center;\n    text-align: center;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
